/**
 * Ligne de prévision liée à une prestation de bordereau (bloc modifiable), avec ou sans lot.
 * Le composant fournit serviceRows (lignes de la même liste) et serviceContextUnit (unité du lot ou de l'étude).
 */
export default {
    computed: {
        isServiceHeader: function () {
            return !!this.prediction.service_block && this.prediction.is_title == 1;
        },
        serviceName: function () {
            return String(this.prediction.designation || '').replace(/\s*\(x[^)]*\)\s*$/, '');
        },
        // Unité de la prestation si elle existe, sinon celle du lot ou de l'étude
        serviceUnit: function () {
            var contextUnit = this.serviceContextUnit ? String(this.serviceContextUnit).trim() : '';

            return this.prediction.service_unit || contextUnit;
        },
        // Lignes de la prestation présentes dans la liste
        serviceLines: function () {
            if (!this.isServiceHeader || !this.serviceRows) {
                return [];
            }

            return this.serviceRows.filter(line => line !== this.prediction && line.service_block === this.prediction.service_block && line.is_title != 1);
        },
        serviceTotal: function () {
            return this.serviceLines.reduce((sum, line) => sum + (parseFloat(line.total) || 0), 0);
        },
        serviceTotalSelling: function () {
            return this.serviceLines.reduce((sum, line) => sum + (parseFloat(line.total_selling) || 0), 0);
        },
        serviceUnitSelling: function () {
            var quantity = parseFloat(this.prediction.service_quantity);

            return quantity > 0 ? this.serviceTotalSelling / quantity : 0;
        },
        // « 0,18 × 120 m² » ; ligne au forfait : « fixe »
        serviceFormula: function () {
            if (this.prediction.unit === 'forfait') {
                return 'fixe';
            }

            var unitQuantity = parseFloat(this.prediction.service_unit_quantity);
            if (isNaN(unitQuantity)) {
                return '';
            }

            return this.formatNumber(unitQuantity, 6) + ' × ' + this.formatNumber(this.prediction.service_quantity, 3) + (this.serviceUnit ? ' ' + this.serviceUnit : '');
        },
    },
    methods: {
        formatNumber: function (value, decimals) {
            return (parseFloat(value) || 0).toLocaleString('fr-FR', {maximumFractionDigits: decimals});
        },
        // Après une saisie de quantité : repère de recalcul retiré, quantité pour 1 unité de la prestation mise à jour
        afterServiceQuantityInput: function (from) {
            if (from === undefined || from === null || typeof from === 'object') {
                this.$delete(this.prediction, 'scaled_from');
            }

            if (this.prediction.service_block && this.prediction.unit !== 'forfait' && parseFloat(this.prediction.service_quantity) > 0) {
                this.$set(this.prediction, 'service_unit_quantity', Math.round(parseFloat(this.prediction.quantity) / parseFloat(this.prediction.service_quantity) * 1000000) / 1000000);
            }
        },
    },
};
